import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Argon from "./plugins/argon-kit";
import BootstrapVue from "bootstrap-vue";
import VueScrollTo from "vue-scrollto";
import VueCarousel from "vue-carousel";
import VueScrollReveal from "vue-scroll-reveal";

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(BootstrapVue);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
Vue.use(VueCarousel);
Vue.use(VueScrollReveal, {
  class: "v-scroll-reveal", // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 500,
  scale: 1,
  distance: "2em",
  mobile: true,
  delay: 500
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
